// The ? button, top right, the account's left neighbour (the UI guide, Features 4): opens the help for the board kind
// in view, and closes it again.

import { CircleHelp } from "lucide-react";
import { cx } from "../lib/util";
import { set, useStore } from "../state/store";
import "./chrome.css";

export function HelpButton() {
  const on = useStore((s) => s.panel === "help");
  return (
    <button className={cx("help-btn island", on && "is-on")} data-help-btn aria-label="Help" aria-pressed={on} data-tip="Help" onClick={() => set((s) => ({ panel: s.panel === "help" ? null : "help", panelArg: null }))}>
      <CircleHelp size={16} />
    </button>
  );
}
